import {
  Button,
  FormInput,
  FormNumber,
  FormRoot,
  FormSwitch,
  RHF,
  zodResolver,
} from "@devhop/ui";
import { z } from "zod";
import type {
  CreateJDLevelFormDTO,
  UpdateJDLevelFormDTO,
} from "../../domain/contracts/level";

const JDLevelFormSchema = z.object({
  name: z.string().min(1, "ກະລຸນາປ້ອນຊື່ລະດັບ"),
  orderIndex: z.number().int().default(0),
  isActive: z.boolean().default(true),
});

export type JDLevelFormValues = z.infer<typeof JDLevelFormSchema>;

export function JDLevelForm({
  initialValues,
  onSubmit,
  submitting,
}: {
  initialValues?: Partial<JDLevelFormValues>;
  onSubmit: (values: CreateJDLevelFormDTO | UpdateJDLevelFormDTO) => void;
  submitting?: boolean;
}) {
  const methods = RHF.useForm<JDLevelFormValues>({
    // biome-ignore lint/suspicious/noExplicitAny: zodResolver type inference issue
    resolver: zodResolver(JDLevelFormSchema) as any,
    defaultValues: {
      name: "",
      orderIndex: 0,
      isActive: true,
      ...initialValues,
    },
  });

  return (
    <FormRoot<JDLevelFormValues>
      methods={methods}
      onSubmit={(vals) =>
        onSubmit({
          name: vals.name,
          orderIndex: vals.orderIndex ?? 0,
          isActive: vals.isActive ?? true,
        })
      }
      className="space-y-4"
    >
      <FormInput
        name="name"
        label="ຊື່ລະດັບ"
        requiredMark
        placeholder="ຕົວຢ່າງ: Junior, Senior, Manager"
      />
      <FormNumber
        name="orderIndex"
        label="ລໍາດັບ"
        placeholder="0"
        hint="ລໍາດັບສໍາລັບການຈັດລຽງ (ຕໍ່່າກ = ສະແດງກ່ອນ)"
      />
      <FormSwitch
        name="isActive"
        label="ໃຊ້ງານ"
        hint="ລະດັບນີ້ຈະສະແດງໃນລາຍການເລືອກລະດັບ"
      />
      <div className="flex justify-end gap-2">
        <Button
          type="button"
          onClick={methods.handleSubmit(onSubmit)}
          disabled={submitting}
          isLoading={submitting}
        >
          ບັນທຶກ
        </Button>
      </div>
    </FormRoot>
  );
}
